var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "head_logo",
    class: {
      collapsed: _vm.collapsed
    }
  }, [_c('div', {
    staticClass: "iw-brand-icon",
    on: {
      "click": _vm.onChange
    }
  }, [_c('img', {
    staticClass: "w-[20px] h-[20px]",
    attrs: {
      "src": require("@/assets/iwork-logo.png"),
      "alt": "",
      "aria-hidden": "true"
    }
  })]), !_vm.collapsed ? _c('span', {
    staticClass: "logo_text"
  }, [_vm._v("iWork")]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };